<template>
  <div class="header-wrap">
    <div class="form-wrap">
      <el-form :rules="rules" :model="formData" ref="headerTplRef">
        <div class="form-item">
          <span class="item-label">选择模板：</span>
          <div class="item-value">
            <el-button class="add-tpl" icon="el-icon-plus" type="text" @click="selectTpl"
              >选择模板</el-button
            >
            <span v-show="tplMsg.tplName" class="tpl-label">模板名称：{{ tplMsg.tplName }}</span>
          </div>
        </div>
        <div class="form-item">
          <span class="item-label" style="padding-top: 6px">广告账户：</span>
          <div class="item-value">
            <el-form-item prop="adCount" style="margin-bottom: 0px">
              <el-select
                v-model="formData.adCount"
                filterable
                :disabled="$route.query.type === 'addGroup'"
                :filter-method="filterMethod"
                class="count-select-wrap"
                popper-class="count-select"
                value-key="advertiserId"
                @change="searchProList()"
                placeholder="请选择账户"
              >
                <el-option
                  v-for="item of countList"
                  :key="item.advertiserId"
                  :label="`${item.advertiserName}`"
                  :value="item.advertiserId"
                >
                  <div class="count-option">
                    <span class="count-item">{{ item.advertiserName }}</span>
                    <span class="count-item">ID：{{ item.advertiserId }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <span class="item-label">推广目标：</span>
          <div class="item-value">
            <el-radio-group v-model="formData.landing_type">
              <el-radio label="APP">应用宣传</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="form-item">
          <span class="item-label" style="padding-top: 6px">选择产品：</span>
          <div class="item-value">
            <el-form-item prop="selectPro">
              <div>
                <el-input
                  style="width: 500px"
                  placeholder="请选择产品"
                  disabled
                  v-model="formData.selectPro"
                >
                  <template slot="append">
                    <el-button @click="chooseProduct" :disabled="!!alreadyCampaignId"
                      >选择</el-button
                    >
                  </template>
                </el-input>
                <span class="create-btn" @click="showCreateProductModal">创建产品</span>
              </div>
              <div class="product-name" v-if="chooseProductData.packageName">
                {{ chooseProductData.appName }}（{{ chooseProductData.packageName }}）
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <!-- 模板选择弹框 -->
    <el-dialog title="选择模板" :visible.sync="dialogVisible" width="1014px">
      <div class="modal-body">
        <div class="select-filter">
          <el-select
            style="width: 224px"
            @change="changeTemplateSearch"
            v-model="modalData.adCount"
            placeholder="请选择"
          >
            <el-option label="全部广告账号" :value="-1"> </el-option>
            <el-option
              :label="item.company + '-' + item.advertiserName"
              :value="item.advertiserId"
              v-for="item of countList"
              :key="item.advertiserId"
            >
            </el-option>
          </el-select>
          <el-input
            style="width: 224px"
            placeholder="请输入内容"
            suffix-icon="el-icon-search"
            v-model.trim="modalData.templateName"
            @change="changeTemplateSearch"
          >
          </el-input>
        </div>
        <div class="table-wrap">
          <el-table
            :data="tplTableList"
            style="width: 100%"
            @select="selectRow"
            ref="tplTableRef"
            max-height="500px"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="id" label="序号"> </el-table-column>
            <el-table-column prop="templateName" label="名称"> </el-table-column>
            <el-table-column prop="templateDesc" label="描述"> </el-table-column>
            <el-table-column prop="advertiserNames" label="关联账号"> </el-table-column>
            <el-table-column prop="createTime" width="170" label="创建时间"> </el-table-column>
            <el-table-column prop="creator" label="创建人"> </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="footer-wrap">
          <self-pagination
            :total="modalData.pageData.total"
            :pageSize="modalData.pageData.size"
            :currentPage="modalData.pageData.page"
            ref="tabelPagination"
            @getCurrentPage="changePage"
            @handleSizeChange="changePageSize"
          ></self-pagination>
          <div></div>
          <div class="bottom-wrap">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmSelect">确 定</el-button>
          </div>
        </span>
      </div>
    </el-dialog>

    <!-- 创建产品弹框 -->
    <el-dialog
      title="创建产品"
      :visible.sync="createProductVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form ref="createProductRef" :model="createProductForm" label-width="90px">
        <el-form-item label="投放平台：">
          <el-radio-group v-model="createProductForm.platform" size="mini">
            <el-radio-button :label="2">Android</el-radio-button>
            <el-radio-button :label="3">IOS</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="产品："
          prop="pkgName"
          :rules="{
            required: true,
            message: '产品不能为空',
            trigger: ['blur', 'change'],
          }"
        >
          <el-input
            v-model="createProductForm.pkgName"
            :placeholder="
              createProductForm.platform === 2 ? '填写包名' : '填写App Store或苹果商店链接'
            "
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createProductVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmCreateProduct" :loading="confirmLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <subpackage-product ref="subpackProduct" @chooseCallback="chooseCallback"></subpackage-product>
  </div>
</template>

<script>
import { queryTemplate, getAdTemplateDatail } from "@/api/promotion-gdt.js";
import { getAdvertiserInfo } from "@/api/promotionReport.js";
import { createGoogleApp } from "@/api/promotion-google.js";
// import SvgIcon from "@/components/SvgIcon.vue";
import SubpackageProduct from "./components/subpackageProduct.vue";
import { mapState } from "vuex";
const googleAppUrl = "https://play.google.com/store/apps/details?id=";
const appleAppUrl = "https://apps.apple.com/app/id";
export default {
  components: {
    SubpackageProduct,
  },
  data() {
    return {
      formData: {
        adCount: "",
        selectPro: "",
        landing_type: "APP",
      },
      confirmLoading: false,
      chooseProductData: {},
      countList: [],
      copyCountList: [],
      proList: [],
      dialogVisible: false,
      createProductVisible: false,
      modalData: {
        adCount: -1,
        searchStr: "",
        pageData: {
          total: 15,
          page: 1,
          size: 10,
        },
      },
      createProductForm: {
        platform: 2,
        pkgName: "",
      },
      tplMsg: {
        tplId: "", //保存的时候需要
        tplDes: "",
        tplName: "",
      },
      tplTableList: [],
      selectData: null, //勾选的模板数据
      rules: {
        adCount: [
          {
            required: true,
            message: "请选择一个账户",
            trigger: "change",
          },
        ],
        selectPro: [
          {
            trigger: ["change"],
            validator: (rule, value, callback) => {
              if (!this.formData.selectPro) {
                callback(new Error("请选择产品"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.initSelect();
  },
  watch: {
    promoteApp: {
      handler(val) {
        if (val) {
          const { appName, packageName, platform, appId } = val;
          let url = platform == 2 ? `${googleAppUrl}${appId}` : `${appleAppUrl}${appId}`;
          this.chooseProductData = {
            packageName,
            appName,
          };
          this.formData.selectPro = appId ? url : "";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      promoteApp: (state) => state.PromotionGoogle.draftCampaign.promoteApp,
      alreadyCampaignId: (state) => state.PromotionGoogle.draftCampaign.campaignId,
    }),
  },
  methods: {
    initSelect() {
      getAdvertiserInfo({
        platType: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
          this.copyCountList = JSON.parse(JSON.stringify(res.advertiseInfos));
        }
      });
    },
    searchProList(data) {
      this.formData.selectPro = "";
      this.chooseProductData = {};
      this.$store.commit("set_ad_series_google", {
        advertiserId: this.formData.adCount,
        advertiserName: this.countList.find((item) => item.advertiserId === this.formData.adCount)
          .advertiserName,
      });
      this.$emit("changeAdCount");
      if (data?.appId) {
        const { appId, platform } = data;
        let url = platform == 2 ? `${googleAppUrl}${appId}` : `${appleAppUrl}${appId}`;
        this.chooseProductData = data;
        this.formData.selectPro = url;
      }
    },
    filterMethod(value) {
      if (value) {
        this.countList = this.copyCountList.filter((item) => {
          return (
            (item.advertiserId + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.advertiserName + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.company + "").toLowerCase().indexOf(value.toLowerCase()) >= 0
          );
        });
      } else {
        this.countList = this.copyCountList;
      }
    },
    changeTemplateSearch() {
      this.modalData.pageData.page = 1;
      this.getTemplateList();
    },
    changePage(page) {
      this.modalData.pageData.page = page;
      this.getTemplateList();
    },
    changePageSize(size) {
      this.modalData.pageData.page = 1;
      this.modalData.pageData.size = size;
      this.getTemplateList();
    },
    getTemplateList() {
      queryTemplate({
        pageNum: this.modalData.pageData.page,
        pageSize: this.modalData.pageData.size,
        advertiserIds: this.modalData.adCount === -1 ? null : this.modalData.adCount,
        templateName: this.modalData.templateName,
        platform: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.tplTableList = res.data.list;
          this.modalData.pageData.total = res.data.total;
        }
      });
    },
    selectTpl() {
      this.dialogVisible = true;
      this.modalData.pageData.page = 1;
      this.getTemplateList();
    },
    selectRow(selection, row) {
      this.selectData = row;
      this.$refs.tplTableRef.clearSelection();
      this.$refs.tplTableRef.toggleRowSelection(row, true);
    },
    confirmSelect() {
      if (this.selectData) {
        this.dialogVisible = false;
        this.renderData();
      } else {
        this.$message({
          message: "请选择一条模板数据",
          type: "warning",
        });
      }
    },
    chooseProduct() {
      if (this.formData.adCount) {
        this.$refs.subpackProduct.showModal(this.formData.adCount);
      } else {
        this.$message({
          message: "请先选择广告账户",
          type: "warning",
        });
      }
    },
    showCreateProductModal() {
      if (this.formData.adCount) {
        this.createProductVisible = true;
        this.createProductForm.pkgName = "";
      } else {
        this.$message({
          message: "请先选择广告账户",
          type: "warning",
        });
      }
    },
    confirmCreateProduct() {
      this.$refs.createProductRef.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          createGoogleApp({
            advertiserId: this.formData.adCount,
            platform: this.createProductForm.platform,
            pkg: this.createProductForm.pkgName,
          }).then((res) => {
            if (res.code === "0000") {
              this.createProductVisible = false;
              this.$message.success("创建成功");
            }
            if (res.code === "6000") {
              this.createProductVisible = false;
              this.$message.warning(res.msg);
            }
            this.confirmLoading = false;
          });
        }
      });
    },
    // 草稿回显
    renderDraft(data) {
      const { advertiserId, promoteApp } = data;
      if (advertiserId) {
        this.formData.adCount = advertiserId;
      }
      if (promoteApp) {
        this.searchProList(promoteApp); //带赋值的查询
      }
    },
    //数据回显
    async renderData() {
      const { id, templateName, templateDesc, advertiserIds } = this.selectData;
      this.tplMsg.tplId = id;
      this.tplMsg.tplName = templateName;
      this.tplMsg.tplDes = templateDesc;
      //赋值广告账号
      if (advertiserIds) {
        this.formData.adCount = advertiserIds;
      }

      const res = await getAdTemplateDatail({ id });
      //表单赋值
      const data = JSON.parse(res.data.templateData);
      this.searchProList(data.draftCampaign.promoteApp); //带赋值的查询
      this.$store.commit("set_creative_groups_google", data.creativeGroups);
      this.$store.commit("set_ad_series_google", data.draftCampaign);
      this.$store.commit("set_adGroup_nameRule_google", data.adGroupNameRule);
      //分配规则
      for (let [field, value] of Object.entries(data.splitRule)) {
        this.$store.commit("set_split_rule_google", {
          key: field,
          value,
        });
      }
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.headerTplRef.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    // 转化跟踪，选择完回调事件
    chooseCallback(data) {
      const { app_cloud_id, app_name, package_name, platform } = data;
      let url = platform == 2 ? `${googleAppUrl}${app_cloud_id}` : `${appleAppUrl}${app_cloud_id}`;
      this.chooseProductData = {
        appId: app_cloud_id,
        appName: app_name,
        packageName: package_name,
        platform: platform,
      };
      this.formData.selectPro = url;
      this.$store.commit("set_ad_series_google", {
        promoteApp: this.chooseProductData,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header-wrap {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .form-wrap {
    padding: 18px 24px 24px 24px;
    .form-item {
      display: flex;
      margin-bottom: 12px;
      .item-label {
        flex-shrink: 0;
        display: inline-block;
        width: 70px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
      .item-value {
        position: relative;
        width: 100%;
        padding-top: 2px;
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(24, 144, 255, 1);
        }
        /deep/ .el-form-item__content {
          line-height: 20px;
        }
        /deep/ .el-input-group__append {
          background: #1890ff;
          color: white;
          cursor: pointer;
          padding: 0;
          width: 70px;
          height: 31px;
          text-align: center;
          .is-disabled {
            width: 70px;
            height: 31px;
            background: #a0cfff;
          }
        }
        .add-tpl {
          padding: 0px;
        }
        .tpl-label {
          font-size: 12px;
          margin-left: 10px;
        }
        .select-tip {
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          position: absolute;
          top: 4px;
          left: 0px;
          z-index: 100;
          pointer-events: none;
        }
        .product-name {
          font-size: 14px;
          margin-top: 6px;
          color: rgb(153, 153, 153);
        }
        .count-select-wrap {
          width: 320px;
          /deep/.el-select .el-input .el-select__caret {
            color: red;
          }
        }
        .select-list {
          margin: 0px;
          padding: 12px 12px 0px 12px;
          box-sizing: border-box;
          list-style: none;
          border-radius: 4px;
          border: 1px solid rgba(239, 239, 239, 1);
          background: rgba(252, 252, 252, 1);
          display: flex;
          flex-wrap: wrap;
          max-height: 125px;
          overflow: auto;
          .select-item {
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            border-radius: 2px;
            background: rgba(233, 233, 233, 0.6);
            padding: 2px 5px;
            margin: 0 12px 12px 0;
            white-space: nowrap;
            .close-btn {
              display: inline-block;
              margin-left: 6px;
              font-size: 18px;
              cursor: pointer;
              position: relative;
              top: 1px;
            }
          }
        }
        .create-btn {
          cursor: pointer;
          color: #1890ff;
          line-height: 40px;
          margin-left: 8px;
        }
      }
    }
  }
  .modal-body {
    .select-filter {
      display: flex;
      justify-content: space-between;
      margin-bottom: 14px;
    }
    .table-wrap {
      min-height: 400px;
    }
    .footer-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bottom-wrap {
        display: flex;
        padding: 16px;
      }
      /deep/ .pagination-wrap {
        text-align: left;
      }
    }
  }
}
</style>
<style lang="less">
.pro-select {
  .el-select-dropdown__item {
    height: 45px;
    line-height: 45px;
  }
  .seitem-wrap {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px;
    box-sizing: border-box;
    .img-wrap {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      .app-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .seitem-content {
      font-size: 12px;
      .app-detail {
        display: block;
        line-height: 16px;
      }
    }
    .os-icon {
      margin: 0 0px 0 auto;
      font-size: 18px;
    }
  }
}
.count-select {
  .el-select-dropdown__item {
    height: 45px;
    line-height: 45px;
  }
  .count-option {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    .count-item {
      display: block;
      line-height: 20px;
    }
  }
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  background-color: rgba(24, 144, 255, 0.1);
  color: rgba(24, 144, 255, 1);
}
</style>
